var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons/faQuestionCircle";
import { faTimes } from "@fortawesome/pro-regular-svg-icons/faTimes";
export const TruffleAlert = (props) => {
    const { CloseIconButtonProps, HelpCenterIconButtonProps } = props, alertProps = __rest(props, ["CloseIconButtonProps", "HelpCenterIconButtonProps"]);
    return (_jsx(Alert, Object.assign({}, alertProps, { action: _jsxs(_Fragment, { children: [props.action, HelpCenterIconButtonProps && (_jsx(IconButton, Object.assign({}, HelpCenterIconButtonProps, { color: props.variant === "filled" ? "white" : undefined, children: _jsx(FontAwesomeIcon, { icon: faQuestionCircle }) }))), CloseIconButtonProps && (_jsx(IconButton, Object.assign({}, CloseIconButtonProps, { color: props.variant === "filled" ? "white" : undefined, children: _jsx(FontAwesomeIcon, { icon: faTimes }) })))] }) })));
};
//# sourceMappingURL=TruffleAlert.js.map